#import "../fragments/comparison-edition-fragment.graphql"

mutation CopyContentToEdition($input: EditionCopyContentToEditionInput!) {
    editionCopyContentToEdition(input: $input) {
        toEdition {
            ...ComparisonEditionFragment
        }
    }
}
